import ObjectDisplay from "../../../../src/mdxTemplates/resourceObjectTemplate";
import { FamilyMemberHistoryObject } from "../../../../src/data/familymemberhistory";
import * as React from 'react';
export default {
  ObjectDisplay,
  FamilyMemberHistoryObject,
  React
};